import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';

interface CatResource {
    StringKey: string;
    StringText: string;
}


@Injectable()
export class CatService {
    private _targetAudience: string = "Default";
    get targetAudience(): string {
        return this._targetAudience;
    }

    set targetAudience(targetAudience: string) {
        this._targetAudience = targetAudience;
        this.load();
    }
    
    private _locale: string = "en";
    getLocale(): string {
        return this._locale;
    }

    setLocale(locale: string): Promise<boolean> {
        this._locale = locale;
        return this.load();
    }
    
    public data: Record<string, string> = {};

    constructor(private http: HttpClient){}

    async load(): Promise<boolean> {
        try {
            const file = await firstValueFrom(this.getFile());
            const keyValuePair: Record<string, string> = {};
            file.forEach((element: any) => {
              keyValuePair[element.StringKey] = element.StringText;
            });
            this.data = keyValuePair;
            return await Promise.resolve(true);
        } catch (err) {
            return await Promise.resolve(false);
        }        
    }

    getFile(): Observable<CatResource[]> {
        return this.http
          .get<CatResource[]>(`./assets/cat_resources/CloudTrayWeb_${this.targetAudience}.${this.getLocale()}.json`);
      }

    getString(key: string): string {
        return this.data?.[key] || key;
    }

    formatString(key: string, ...values: Array<string | number>): string {
        return values.reduce<string>(
            (text, value, index) => text.replace(new RegExp(`\\{${index}\\}`, 'g'), String(value)),
            this.getString(key)
        );
    }
}
